(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  function closeCard(card) {
    if (!card) return;
    card.removeAttribute('data-open');
    card.querySelector('[data-toonie-spine-link]')?.setAttribute('aria-expanded', 'false');
  }

  function openCard(card) {
    const wall = card.closest('[data-toonie-wall]');
    wall?.querySelectorAll('[data-toonie-card][data-open]').forEach((open) => {
      if (open !== card) closeCard(open);
    });
    card.setAttribute('data-open', 'true');
    card.querySelector('[data-toonie-spine-link]')?.setAttribute('aria-expanded', 'true');
  }

  function initWall(wall) {
    if (wall.dataset.toonieReady === 'true') return;
    wall.dataset.toonieReady = 'true';

    const rows = wall.querySelector('[data-toonie-rows]');
    const search = wall.querySelector('[data-toonie-search]');
    const count = wall.querySelector('[data-toonie-count]');
    const empty = wall.querySelector('[data-toonie-empty]');
    const cards = Array.from(wall.querySelectorAll('[data-toonie-card]'));
    const shelfLabel = wall.dataset.shelfLabel || 'Shelf';

    function renderSearch() {
      const query = (search?.value || '').trim().toLowerCase();
      const visible = cards.filter((card) => !query || card.dataset.title.includes(query));

      if (rows) {
        rows.replaceChildren();
        for (let index = 0; index < visible.length; index += 10) {
          const row = document.createElement('div');
          row.className = 'toonie-shelf-row';
          row.setAttribute('role', 'list');
          row.setAttribute('aria-label', shelfLabel + ' ' + (index / 10 + 1));

          const marker = document.createElement('span');
          marker.className = 'toonie-shelf-row__marker';
          marker.setAttribute('aria-hidden', 'true');
          marker.textContent = shelfLabel + ' ' + (index / 10 + 1);

          const tapes = document.createElement('div');
          tapes.className = 'toonie-shelf-row__tapes';
          visible.slice(index, index + 10).forEach((card) => tapes.append(card));

          row.append(marker, tapes);
          rows.append(row);
        }
      }

      if (count) count.textContent = String(visible.length) + ' tapes shown';
      if (empty) empty.hidden = visible.length !== 0;
    }

    wall.addEventListener('submit', async (event) => {
      const form = event.target.closest('form[data-type="add-to-cart-form"]');
      if (!form || !wall.contains(form)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const button = form.querySelector('button[name="add"]');
      const liveRegion = form.closest('product-form-component')?.querySelector('[ref="liveRegion"]');
      const addLabel = button?.dataset.labelAdd || 'Add to cart';
      const addedLabel = button?.dataset.labelAdded || 'Added to cart';
      const errorLabel = button?.dataset.labelError || 'Could not add this tape';

      if (button) {
        button.disabled = true;
        button.textContent = addedLabel.replace('Added', 'Adding');
      }

      try {
        const response = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin',
          body: new FormData(form)
        });
        const result = await response.json();

        if (!response.ok || result.status) {
          throw new Error(result.description || result.message || errorLabel);
        }

        const cartResponse = await fetch('/cart.js', { credentials: 'same-origin' });
        const cart = await cartResponse.json();

        if (button) button.textContent = addedLabel;
        if (liveRegion) liveRegion.textContent = addedLabel;

        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'toonie-vhs-wall',
            data: {
              source: 'toonie-vhs-wall',
              itemCount: 1
            }
          }
        }));
      } catch (error) {
        if (button) button.textContent = errorLabel;
        if (liveRegion) liveRegion.textContent = error.message || errorLabel;
      } finally {
        window.setTimeout(() => {
          if (!button) return;
          button.disabled = false;
          button.textContent = addLabel;
        }, 1200);
      }
    }, true);

    wall.addEventListener('input', (event) => {
      if (event.target.matches('[data-toonie-search]')) renderSearch();
    });

    wall.addEventListener('change', (event) => {
      if (!event.target.matches('[data-toonie-submit]')) return;
      event.target.form?.requestSubmit();
    });

    wall.addEventListener('click', (event) => {
      const spine = event.target.closest('[data-toonie-spine-link]');
      if (!spine || !mobileQuery.matches) return;
      const card = spine.closest('[data-toonie-card]');
      if (!card?.hasAttribute('data-open')) {
        event.preventDefault();
        openCard(card);
      }
    });

    wall.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const card = event.target.closest('[data-toonie-card]');
      if (!card?.hasAttribute('data-open')) return;
      closeCard(card);
      card.querySelector('[data-toonie-spine-link]')?.focus();
    });

    document.addEventListener('click', (event) => {
      if (!mobileQuery.matches || wall.contains(event.target)) return;
      wall.querySelectorAll('[data-toonie-card][data-open]').forEach(closeCard);
    });

    renderSearch();
  }

  function init() {
    document.querySelectorAll('[data-toonie-wall]').forEach(initWall);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
